import React from "react";
import MaterialIcon from "./MaterialIcon";
import { getProjectTagColors } from "../utils/projectTagColor";

/**
 * ProjectTagActionModal
 *
 * Shown when the user clicks a project-association tag on an email. Offers
 * navigate (messages inbox), change association, and remove. Navigate is
 * omitted when already in that room. Reuses the shared .email-classify-* styles.
 */
function ProjectTagActionModal({ project, projectColor, onNavigate, onChange, onRemove, onClose, strings = {} }) {
  const tc = getProjectTagColors(projectColor || (project && project.themeColor));
  const showNavigate = typeof onNavigate === "function";
  const showChange = typeof onChange === "function";
  return (
    <div className="email-classify-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="email-classify-modal" onClick={(e) => e.stopPropagation()}>
        <div className="email-classify-header">
          <div className="email-classify-title">
            <MaterialIcon icon="folder" size={20} color={tc.fg} />
            <span>{project?.name || (strings.email_in_project || "Project")}</span>
          </div>
          <button className="kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral" onClick={onClose} title={strings.cancel || "Close"}>
            <MaterialIcon icon="close" size={18} />
          </button>
        </div>

        <div className="email-classify-section">
          {showNavigate && (
            <button
              className="kj-btn kj-btn--primary kj-btn--email kj-btn--block email-classify-btn"
              onClick={onNavigate}
            >
              <MaterialIcon icon="open_in_new" size={16} />
              <span>{strings.email_project_navigate || "Navigate to project"}</span>
            </button>
          )}
          {showChange && (
            <button
              className={`kj-btn kj-btn--secondary kj-btn--block email-classify-btn${showNavigate ? " mt-2" : ""}`}
              onClick={onChange}
            >
              <MaterialIcon icon="edit" size={16} />
              <span>{strings.email_project_change || "Change project association"}</span>
            </button>
          )}
          {onRemove && (
            <button
              className={`kj-btn kj-btn--outline kj-btn--danger kj-btn--block email-classify-btn${(showNavigate || showChange) ? " mt-2" : ""}`}
              onClick={onRemove}
            >
              <MaterialIcon icon="link_off" size={16} />
              <span>{strings.email_project_remove || "Remove project association"}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProjectTagActionModal;
